export const profile = {
  profileSettings: 'Kontoeinstellungen',
  editProfileData: 'Benutzerdaten ändern',
  firstName: 'Vorname',
  lastName: 'Nachname',
  email: 'E-Mail',
  saveChanges: 'Änderungen speichern',
  changePassword: 'Passwort ändern',
  currentPassword: 'Aktuelles Passwort',
  newPassword: 'Neues Passwort',
  repeatPassword: 'Neues Passwort wiederholen',
  updateUserDataSuccessText: 'Ihre Benutzerdaten wurden erfolgreich gespeichert.',
  updateUserDataErrorText: 'Ihre Benutzerdaten konnten nicht gespeichert werden.',
  updatePasswordSuccessText: 'Ihr Passwort wurde erfolgreich geändert.',
  updatePasswordErrorText: 'Ihr Passwort konnte nicht geändert werden.',
  realEstateOverview: 'Immobilienübersicht',
  realEstate: 'Immobilie',
}
